
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  toRefs,
  watch,
  PropType
} from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import ParticipantReplay from "@/components/participant/modal/participantModalReplay.vue";
import ParticipantFinish from "@/components/participant/modal/participantModalFinish.vue";
import ParticipantList from "@/components/participant/modal/participantModalList.vue";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters
} from "@/store/enums/participationEnums";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
  EventType
} from "@/store/enums/paramsEnums";
import groupHeaderModel from "@/core/models/share/status.interface";
import { useStore } from "vuex";
import { useThemeVars } from "naive-ui";
import { changeColor } from "seemly";
import { useRouter, useRoute } from "vue-router";
import {
  Module as ExposedModule,
  Actions as ExposedActions,
  Mutations as ExposedMutations,
  Getters as ExposedGetters
} from "@/store/enums/exposedEnums";
import { contentParticipantInfo as ExposedParticipantInfoI } from "@/core/models/share/content.interface";
import { useI18n } from "vue-i18n";
import { useMessage } from "naive-ui";
import { IosInformationCircle, IosCheckmarkCircle, MdCloseCircle } from "@vicons/ionicons4";

export default defineComponent({
  name: "participantModal",
  components: { ParticipantReplay, ParticipantFinish, ParticipantList, IosInformationCircle, IosCheckmarkCircle, MdCloseCircle },
  props: {
    showModal: { type: Boolean, required: true, default: false },
    eventColor: { type: String, default: "#111111" },
    eventID: { type: String, default: "0" },
    statusHeaders: {
      type: Array as PropType<Array<groupHeaderModel>>,
      required: true
    },
    eventType: { type: null, default: 1 }
  },
  setup(props: any, context: any) {
    const store = useStore();
    const router = useRoute();
    const Router = useRouter();
    const { t, locale } = useI18n();
    const themeVars = useThemeVars();
    const isExpanded = ref(false);
    const isReadMore =  computed(
      function() {
        const re = ref(false)
        if (event.value.Description != null )
        {
          if (event.value.Description.length > 20){
              re.value = true
          }
          else{
            re.value = false
          }
        }
        return re.value
      }     
    )

    const displayText =  computed(
      function() {
        const re = ref("")
        if (event.value.Description != null )
        {
          if (isExpanded.value == false && event.value.Description.length > 20){
              re.value = event.value.Description.substring(0,13)
          }
          else{
            re.value = event.value.Description
          }
        }
        return re.value
      }     
    )
    const userRes = computed<ExposedParticipantInfoI>(
      () =>
        store.getters[ExposedModule.desc + ExposedGetters.EventPartRespStatus]
    );

    const event = computed<inviteEventModel>(
      () =>
        store.getters[ExposedModule.desc + ExposedGetters.TheParticipantEvent]
    );

    const bodyStyle = {
      //width: "1000px",
    };
    const contentStyle = {
      "padding-top": "15px"
    };
    const headerStyle = ref({
      background: "#EDEFF2",
      border: "radius",
      color: "#fff",
      type: themeVars.value.infoColor
    });
    const startDate = ref<Date>(new Date());

    async function onClose() {
      // context.emit("modalClose", false);
      // startDate.value = new Date();
      // await store.dispatch(
      //   ParticipationModule.desc + ParticipationActions.LoadEventsMyResponses
      // );
      // await store.dispatch(Module.desc + Actions.HandMyParticipantEvents);

      if (router.query.EventParticipantId != undefined) {
        Router.replace({ query: {} });
        localStorage.removeItem("State");
        localStorage.removeItem("EventHeaderId");
      }

      window.location.href = "about:blank";
      window.close();
    }

    function datetimeString(date: string) {
      if (dayjs( date).format("MMDD") == dayjs( new Date()).format("MMDD"))
        return dayjs( date).format("HH:mm");
      else return dayjs( date).format("MM/DD");
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    function typeColor(status: string) {
      let result = "#dc0005";
      switch (status) {
        case ParamEventStatus.Open:
          result = "warning";
          headerStyle.value.background = themeVars.value.infoColor;
          headerStyle.value.type = themeVars.value.warningColor;
          break;
        case ParamEventStatus.Close:
          result = "info";
          headerStyle.value.background = themeVars.value.buttonColor2Pressed;
          headerStyle.value.type = themeVars.value.infoColor;
          break;
        case ParamEventStatus.Cancel:
          result = "info";
          headerStyle.value.background = themeVars.value.buttonColor2Pressed;
          headerStyle.value.type = themeVars.value.infoColor;
          break;
      }
      return result;
    }

    const tabs = [
      {
        index: 0,
        name: "replay",
        display: "Replay"
      },
      {
        index: 1,
        name: "list",
        display: "List"
      }
    ];
    const selectedTab = ref(0);
    function tabType(id: number) {
      if (id == 0) {
        if (id == selectedTab.value) return null;
        else return true;
      } else if (id == 1) {
        if (id == selectedTab.value) return null;
        else return true;
      }
    }

    function toggleReadMore(){
      isExpanded .value = !isExpanded.value
    }


    // const handleDialog = ()=>{
    //   dialog.warning({
    //     title: 'Confirm',
    //     content: 'Are you '+ userRes.value.Member.Name +'?',
    //     positiveText: 'YES',
    //     negativeText: 'No',
    //     onPositiveClick: () => {
    //       //message.success('Sure')
    //     },
    //     onNegativeClick: () => {
    //       message.error('Please confirm your link.')
    //     }
    //   })
    // }
    const showConfirmModal = ref(true);
    const message = useMessage()
    const onPositiveClick = ()=>{
      showConfirmModal.value = false;
    }
    const onNegativeClick = ()=>{
      message.error('Please confirm your link.')
      showConfirmModal.value = false;
      onClose();
    }
    const contentTxt = () => {
      return `Are you ${userRes.value.Member.Name}?`;
    }
    onMounted(async () => {});

    return {
      ParamEventStatus,
      bodyStyle,
      contentStyle,
      headerStyle,
      onClose,
      event,
      datetimeString,
      percentage,
      startDate,
      typeColor,
      EventType,
      themeVars,
      changeColor,
      tabs,
      selectedTab,
      tabType,
      userRes,
      t,
      showConfirmModal,
      onPositiveClick,
      onNegativeClick,
      isExpanded,
      displayText,
      toggleReadMore,
      isReadMore
    };
  }
});
